export const dynamic = "force-dynamic";

import { initializeApp, getApps } from "firebase/app";
import { getAuth, Auth } from "firebase/auth";
import { getFirestore, Firestore } from "firebase/firestore";
import { debugLog, debugError } from "./debug";

// Firebase config
const firebaseConfig = {
  apiKey: process.env.NEXT_PUBLIC_FIREBASE_API_KEY,
  authDomain: process.env.NEXT_PUBLIC_FIREBASE_AUTH_DOMAIN,
  projectId: process.env.NEXT_PUBLIC_FIREBASE_PROJECT_ID,
  storageBucket: process.env.NEXT_PUBLIC_FIREBASE_STORAGE_BUCKET,
  messagingSenderId: process.env.NEXT_PUBLIC_FIREBASE_MESSAGING_SENDER_ID,
  appId: process.env.NEXT_PUBLIC_FIREBASE_APP_ID,
};

const isServer = typeof window === "undefined";

// Initialize Firebase only on the client
const app = !isServer
  ? (!getApps().length ? initializeApp(firebaseConfig) : getApps()[0])
  : null;

// --- SAFE PROXY WRAPPERS --------------------------------------------------
// These prevent SSR crashes and satisfy TypeScript without returning null.

function ssrGuard<T>(name: string): T {
  return new Proxy(
    {},
    {
      get() {
        throw new Error(`Firebase ${name} cannot be used during SSR`);
      },
    }
  ) as T;
}

export const auth: Auth = isServer ? ssrGuard<Auth>("auth") : getAuth(app!);
export const db: Firestore = isServer ? ssrGuard<Firestore>("firestore") : getFirestore(app!);

// Optional debug logging
if (isServer) {
  debugLog("Firebase skipped during SSR");
} else if (!firebaseConfig.apiKey) {
  debugError("Missing Firebase config");
  debugLog("Firebase config:", firebaseConfig);
}

export default app;